import { defineComponent as _defineComponent } from 'vue';
import { nextTick } from 'vue';
import { useFrameStore } from './seg-frame-store';
import { TABS } from './helpers/frameConstants';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SidebarFooter',
    setup(__props, { expose: __expose }) {
        __expose();
        const store = useFrameStore();
        const handleCopyBOM = () => {
            const lines = ['BOM:'];
            store.activeFrameData?.bom.forEach(b => lines.push(`${b.name}\t${b.qty}\t${b.len}"`));
            navigator.clipboard.writeText(lines.join('\n'))
                .then(() => alert('BOM copied to clipboard!'))
                .catch(() => alert('Copy failed.'));
        };
        const printWith = async (internal) => {
            store.isInternalPrintView = internal;
            await nextTick();
            window.print();
        };
        const handleDownloadCSV = () => {
            const data = store.activeFrameData;
            if (!data)
                return;
            const lines = [['Section', 'Part', 'Qty', 'Len (in)'].join(',')];
            data.bom.forEach(b => {
                lines.push(['BOM', `"${b.name.replace(/"/g, '""')}"`, b.qty, b.len].join(','));
            });
            Object.entries(data.hw).forEach(([k, v]) => {
                if (!v || v <= 0)
                    return;
                const lbl = k.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase());
                lines.push(['Hardware', `"${lbl.replace(/"/g, '""')}"`, v, ''].join(','));
            });
            const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `SEG_CutList_${data.dims.w}x${data.dims.h}.csv`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        };
        const __returned__ = { store, handleCopyBOM, printWith, handleDownloadCSV, get TABS() { return TABS; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
